import PropTypes from 'prop-types'
import React from 'react'
import {Link} from 'react-router-dom'

import LazyLoadImage from '../LazyLoad/LazyLoadImage'

const ProductSetItem = ({handleClick, itemName, productImage, url}) => (
  <Link className="product-set-item" to={url} onClick={handleClick}>
    <div className="o-frame o-frame--thumbnail">
      <div className="o-frame__canvas">
        <LazyLoadImage
          alt={`The Black Tux's ${itemName} against a neutral backdrop`}
          src={productImage}
          className="o-frame__media"
        />
      </div>
    </div>
    <h3 className="product-set-item__name">{itemName}</h3>
  </Link>
)

ProductSetItem.propTypes = {
  handleClick: PropTypes.func.isRequired,
  itemName: PropTypes.string.isRequired,
  productImage: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
}

export default ProductSetItem
